import { z } from 'zod';
import { TFunction } from 'i18next';

export const createTeamFormSchema = (t: TFunction) => z.object({
  name: z.string().min(1, t('teams.validation.nameRequired')),

  numberOfTeamMembers: z.preprocess(
    (value) => {
      if (typeof value !== 'string') return undefined;

      const trimmed = value.trim();
      if (trimmed === '') return undefined;

      if (!/^\d+$/.test(trimmed)) return undefined;

      return Number(trimmed);
    },
    z
      .number({
        required_error: t('teams.validation.membersRequired'),
        invalid_type_error: t('teams.validation.membersRequired'),
      })
      .int()
      .min(3, t('teams.validation.membersMinimum')),
  ),
});

export type TeamFormValues = z.infer<ReturnType<typeof createTeamFormSchema>>;
